var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCameraIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_ionic-ios-camera",
    "data-name": "Icon ionic-ios-camera",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 22.8,
    viewBox: "0 0 30 22.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M22.941,19.845a4.493,4.493,0,1,1-4.492-4.552A4.522,4.522,0,0,1,22.941,19.845Z",
    transform: "translate(-3.449 -6.941)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M32.117,11.675H27.859a1.261,1.261,0,0,1-.938-.428C24.7,8.73,23.867,7.875,22.961,7.875h-6.68c-.914,0-1.812.855-4.039,3.38a1.236,1.236,0,0,1-.93.42h-.32v-.633a.631.631,0,0,0-.625-.633H8.336a.631.631,0,0,0-.625.633v.633H7.125A2.547,2.547,0,0,0,4.5,14.105V28.039a2.723,2.723,0,0,0,2.617,2.636h25A2.524,2.524,0,0,0,34.5,28.039V14.105A2.344,2.344,0,0,0,32.117,11.675ZM19.813,27.54A6.769,6.769,0,1,1,26.172,21.1,6.731,6.731,0,0,1,19.813,27.54ZM27,16.267a1.029,1.029,0,1,1,1.016-1.029A1.02,1.02,0,0,1,27,16.267Z",
    transform: "translate(-4.5 -7.875)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/camera-icon.814a38ee545f6ccc1c72684d510d49e7.svg";
export { ForwardRef as ReactComponent };